<template>
  <div class="page-wrap DeviceList-page" ref="container">
		<Search :label="searchLabel" :dateFilter="false" @search="search" ref='search'></Search>
		<List title="报修记录列表" :refresh="true" :config="config" :label="label" apiName="petDeviceRepairsList" ref="list"></List>
  </div>
</template>
<script>
import Search from "@components/Search";
import List from "@components/List";

export default {
  name: "PetAdminRepairsList",
  components: {
		Search,
		List,
  },
  props: {},
  data: function() {
    return {
      filter: {
      },
			searchLabel : [
				{field : 'machineCode', title : '设备编码'},
			],
			label : [
				{field : 'deviceSn', title : '设备编码'},
				{field : 'address', title : '设备地址'},
				{field : 'name', title : '设备名称'},
				{field : 'createTime', title : '报障时间'},
				{field : 'statusStr', title : '状态', valueStyle : [{color: '#F9372D'}, {color: '#3DC60C'}], prop : 'status'},
				{field : 'repairsTime', title : '处理时间'},
				{field : 'content', title : '故障描述', type : "status"},
			],
    };
  },
  watch: {
    $route(n) {
      if (n.name === 'PetAdminRepairsList') {
    		let prevPage = this.$prevRoute();
    		if (prevPage && prevPage.name == "PetAdmin") {
    			this.$refs.search.reSet();
    			this.filter = {};
    			this.search(this.filter);
    		}
      }
    }
  },
  mounted: function() {
  },
  computed: {},
  methods: {
		search(filter) {
			this.filter = filter;
			this.$refs.list.reload(filter);
		},
  }
};
</script>
<style lang="scss">
body {background: #F9F9F9 !important;}
.page-wrap {
	padding: 0.3rem;
}
</style>
